<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pb-2 mb-2 globalborder-btm-header px-3">
        <span class="col-auto">
          <h2 class="mb-0">Proposal Email</h2>
        </span>
        <span
          *ngIf="isModal"
          (click)="closeProposalEmailModal()"
          class="d-flex gap-2 customizefilter-btn">
          <span class="cross-border"><i class="pi pi-times"></i></span>
        </span>
      </span>
      <div class="adduser-container-hgt px-3">
        <jni-display-pdf-frame-quote
          *ngIf="!poEmailScreenStatus"
          [quoteId]="quoteId"
          [parent]="poEmailForm"
          [templatesList]="poTemplates"
          (emailSelectionEvent)="emailSelection()"
          (templateSelectedEvent)="templatedSelected($event)">
        </jni-display-pdf-frame-quote>
        <jni-po-email-header-quote
          #poheader
          *ngIf="poEmailScreenStatus"
          [parent]="poEmailForm"
          [poNumber]="purchaseOrderNumberList"
          [templates]="poTemplates"
          [formErrors]="formErrors"
          [validationMessages]="validationMessages"
          (waterMarkPdfEvent)="waterMarkPdf($event)"
          (fetchVendorInformation)="getCustomerInformationForPOEmail(false)"
          (templateSelectedEvent)="templatedSelected($event)"
          (logValidationErrorsEvent)="logValidationErrors()">
        </jni-po-email-header-quote>

        <div class="row mb-4">
          <div class="col-md-6">
            <jni-po-email-recipients
              *ngIf="poEmailScreenStatus"
              [recipientsList]="recipientsList"
              (recipientsDeletedEvent)="recipientsDeleted($event)"
              (recipientsAddEvent)="recipientsAdd()"></jni-po-email-recipients>
            <div class="mt-4">
              <div class="attachmentsection">
                <jni-po-email-attachments
                  *ngIf="poEmailScreenStatus"
                  (attachmentFileArrayEvent)="getAttachmentFileArray($event)"
                  (TotalFileSizeEvent)="getTotalFileSize($event)"
                  (attachmentFileArrayUrlEvent)="attachmentFileUrlArray($event)"
                  [fileName]="fileName">
                </jni-po-email-attachments>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <jni-po-email-contacts
              *ngIf="poEmailScreenStatus"
              [contactsList]="clientAndProspectContacts"
              (addCCEvent)="addCC($event)"
              (addTOEvent)="addTO($event)"></jni-po-email-contacts>
          </div>
        </div>

        <div class="mb-5">
          <jni-editor
            #emailComponent
            *ngIf="poEmailScreenStatus"
            (templateEvent)="template()"
            (sendEmail)="sendEmail($event)"
            [displaySendButton]="displaySendButton"
            [htmlBody]="templateBody"></jni-editor>
        </div>
      </div>
    </p-card>
  </div>
</div>
